import React from "react";

export default function ListMenu({ userType }) {
  const isSuperVisible = userType !== 2; // Hide for userType 3 only

  const menuItems = [
    { label: "Super", visible: isSuperVisible, className: "menuUsername" },
    { label: "Username", className: "menuUsername" },
    { label: "Booked", className: "menuUsername" },
    { label: "Net-Booked", className: "menuUsername" },
    { label: "Sharing", className: "menuName" },
    { label: "Tpassword", className: "menuName" },
    { label: "Trade", className: "menuName" },
    { label: "Close Only", className: "menuName" },
    { label: "Status", className: "menuName" },
    { label: "IP Address", className: "menuName" },
    { label: "Created Date", className: "menuName" },
    { label: "Last Login", className: "menuName" },
    { label: "", className: "menuName" },
  ];

  return (
    <div className="menuContainer primary white">
      {menuItems
        .filter(item => item.visible !== false)
        .map((item, index) => (
          <div key={index} className={item.className}>
            {item.label}
          </div>
        ))}
    </div>
  );
}
